import React, { createContext, Component, useEffect, useState } from 'react';
import dictionary from '../../utils/dictionary';
import ajaxReports from '../../utils/remote/ajaxReports';
import { detectTable, restoreTable } from '../../utils/script/customTables';



const eformat = dictionary._exportBtnFormats;
const SpaceInventoryContext = React.createContext({});
export const SpaceInventoryConsumer = SpaceInventoryContext.Consumer;


export const SpaceInventoryProvider = (props) => {

    const [spaceInventoryList, setSpaceInventory] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [data, setdata] = useState({ "page": 1, "street_id": "", "date_from": "", "date_to": "", "location_id": "" });
    const [metaData, setMetaData] = useState(false)

    // useEffect(() => {
    //     listspaceInventory();

    // }, [data])

    useEffect(() => {
        if (currentPage > 1) {
            fetchMoreTrigger()
        }
    }, [currentPage])


    const fetchMoreTrigger = () => {
        const newData = {
            ...data,
            "page": currentPage,
        }
        fetchMore(newData)
    }


    const filterData = (options) => {
        setCurrentPage(1);
        setdata({
            "page": 1,
            "street_id": options.selectedValue,
            "date_from": options.dateFrom,
            "date_to": options.dateTo,
            "location_id": options.selectedValue6
        })
    }

    const resetData = () => {
        setCurrentPage(1)
        setdata({ "page": 1, "street_id": "", "date_from": "", "date_to": "", "location_id": "" })
    }

    const listspaceInventory = async () => {
        setLoading(true)
        setMetaData(false)
        setSpaceInventory(false)
        const server_response = await ajaxReports.locationAverageParkingTime(data)
        setLoading(false)
        if (server_response.status === 'OK') {
            setSpaceInventory(server_response.details.content.list)
            setMetaData(server_response.details.content.meta)
        }
        else {
            setSpaceInventory("404")
            setMetaData(false)
        }

    }

    /**Fethes more data from the server 
     * and appends it to already existing data */
    const fetchMore = async (newData) => {
        setLoading(true)
        restoreTable(detectTable())
        const server_response = await ajaxReports.locationAverageParkingTime(newData);
        setLoading(false)
        if (server_response.status === "OK") {

            const incoming = Array.from(server_response.details.content.list);
            setSpaceInventory(spaceInventoryList.concat(incoming));
            setMetaData(server_response.details.content.meta)
        }
    }


    const goToNextPage = () => {
        if (currentPage < metaData.total_pages) {
            setCurrentPage(currentPage + 1);
        }
    }


    const getFreshObject = () => {

        return [{
            "street": ""
        },

        {
            "branch": ""
        },
        {
            "dateFrom": ""
        },
        {
            "dateTo": ""
        }
        ]
    }







    return (
        <SpaceInventoryContext.Provider value={{
            listspaceInventory,
            spaceInventoryList,
            fetchMore,
            loading,
            metaData,
            filterData,
            resetData,
            goToNextPage
        }}>
            {props.children}
        </SpaceInventoryContext.Provider>
    );


}
export default SpaceInventoryContext;